import React, {useMemo, useState} from 'react';
import LaunchExperience from './LaunchExperience';
import LaunchLanding from './LaunchLanding';
import './styles.css';

export default function LaunchPresentationTool() {
  const isLaunchWindow = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('view') === 'launch';
  }, []);

  const [popupBlocked, setPopupBlocked] = useState(false);

  const openLaunchWindow = () => {
    const launchUrl = new URL(window.location.href);
    launchUrl.searchParams.set('view', 'launch');

    const width = Math.min(1600, window.screen.availWidth || 1440);
    const height = Math.min(1000, window.screen.availHeight || 900);
    const left = Math.max(0, Math.round((window.screen.availWidth - width) / 2));
    const top = Math.max(0, Math.round((window.screen.availHeight - height) / 2));

    const launchWindow = window.open(
      launchUrl.toString(),
      'ProsperityLaunch',
      `popup=yes,width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=no`
    );

    if (!launchWindow) {
      setPopupBlocked(true);
      return;
    }

    setPopupBlocked(false);
    launchWindow.focus();
  };

  return (
    <div className="lpt-shell">
      {isLaunchWindow
        ? <LaunchExperience />
        : <LaunchLanding onLaunch={openLaunchWindow} popupBlocked={popupBlocked} />}
    </div>
  );
}
